(function () {
  "use strict";
  if (window.__lgSeasonalIssueLoader) return;
  window.__lgSeasonalIssueLoader = true;

  var sources = Object.create(null);
  var inited = new WeakSet();

  function articlePath(href) {
    try { return new URL(href, window.location.href).pathname; }
    catch (error) { return href || ""; }
  }

  function sameLinks(container, selector, entries) {
    var actual = Array.prototype.map.call(container.querySelectorAll(selector), function (link) {
      return articlePath(link.getAttribute("href"));
    });
    return actual.length === entries.length && actual.every(function (href, index) {
      return href === entries[index].path;
    });
  }

  async function loadIssue(url, tag) {
    var requestUrl = new URL(url, window.location.href);
    if (requestUrl.origin !== window.location.origin) throw new Error("Magazine: invalid origin");
    var seen = new Set();
    var entries = [];
    while (requestUrl) {
      if (seen.has(requestUrl.href)) throw new Error("Magazine: circular pagination");
      seen.add(requestUrl.href);
      var response = await fetch(requestUrl.href, {
        credentials: "same-origin",
        headers: { "X-Requested-With": "XMLHttpRequest" }
      });
      if (!response.ok) throw new Error("Magazine: response " + response.status);
      var documentPage = new DOMParser().parseFromString(await response.text(), "text/html");
      var grid = documentPage.querySelector("[data-tagged-grid]");
      if (!grid) throw new Error("Magazine: missing native tagged grid");
      Array.prototype.forEach.call(grid.querySelectorAll("[data-card]"), function (card) {
        var anchor = card.querySelector(".blog-post-card__title[href]");
        if (!anchor) return;
        var tags = (card.getAttribute("data-tags") || "").split("|");
        if (tags.indexOf(tag) === -1) return;
        entries.push({
          path: articlePath(anchor.getAttribute("href")),
          href: anchor.getAttribute("href"),
          title: anchor.textContent.trim(),
          tags: tags,
          card: card
        });
      });
      var next = documentPage.querySelector(".magazine-pagination a[rel='next']");
      requestUrl = next ? new URL(next.getAttribute("href"), response.url) : null;
      if (requestUrl && requestUrl.origin !== window.location.origin) {
        throw new Error("Magazine: external pagination blocked");
      }
    }
    return entries;
  }

  function source(url, tag) {
    var key = url + "|" + tag;
    if (!sources[key]) {
      sources[key] = loadIssue(url, tag).catch(function (error) {
        delete sources[key];
        throw error;
      });
    }
    return sources[key];
  }

  function categoryFrom(tags) {
    return tags.find(function (tag) {
      var lower = tag.toLowerCase();
      return lower.indexOf("numero") === -1 &&
        ["Archives de produits", "Templates", "exclude-from-email", "featured"].indexOf(tag) === -1;
    }) || "";
  }

  function renderToc(root, articles) {
    if (sameLinks(root, ".magazine-toc__article-title[href]", articles)) return;
    var perSlide = Math.max(1, parseInt(root.dataset.perSlide, 10) || 10);
    var roman = root.dataset.numberFormat === "roman";
    var carouselId = root.dataset.carouselId;
    var oldCarousel = root.querySelector("scroll-carousel.magazine-toc__carousel");
    var oldEmpty = root.querySelector(".magazine-toc__empty");
    var header = root.querySelector(".magazine-toc__header");
    if (!header && articles.length) {
      header = document.createElement("div");
      header.className = "magazine-toc__header";
      root.insertBefore(header, oldCarousel || oldEmpty || null);
    }
    if (!articles.length) {
      if (oldCarousel) oldCarousel.remove();
      if (!oldEmpty) {
        oldEmpty = document.createElement("p");
        oldEmpty.className = "magazine-toc__empty";
        root.appendChild(oldEmpty);
      }
      oldEmpty.textContent = "Aucun article dans ce numéro pour le moment.";
      return;
    }
    var carousel = document.createElement("scroll-carousel");
    carousel.id = carouselId;
    carousel.setAttribute("cell-selector", ".magazine-toc__slide");
    carousel.setAttribute("allow-drag", "");
    carousel.className = "scroll-area snap-x magazine-toc__carousel";
    for (var i = 0; i < articles.length; i += perSlide) {
      var slide = document.createElement("div");
      slide.className = "magazine-toc__slide snap-center";
      var list = document.createElement("ol");
      list.className = "magazine-toc__list";
      articles.slice(i, i + perSlide).forEach(function (entry, j) {
        var index = i + j + 1;
        var li = document.createElement("li");
        li.className = "magazine-toc__item";
        var number = document.createElement("span");
        number.className = "magazine-toc__num";
        if (roman && index <= 50) {
          var values = [40, 10, 9, 5, 4, 1];
          var chars = ["XL", "X", "IX", "V", "IV", "I"];
          var remaining = index, result = "";
          values.forEach(function (value, x) {
            while (remaining >= value) { result += chars[x]; remaining -= value; }
          });
          number.textContent = result + ".";
        } else {
          number.textContent = index + ".";
        }
        var link = document.createElement("a");
        link.href = entry.href;
        link.className = "magazine-toc__article-title";
        link.textContent = entry.title;
        li.appendChild(number);
        li.appendChild(link);
        var category = categoryFrom(entry.tags);
        if (category) {
          var label = document.createElement("span");
          label.className = "magazine-toc__category";
          label.textContent = category;
          li.appendChild(label);
        }
        list.appendChild(li);
      });
      slide.appendChild(list);
      carousel.appendChild(slide);
    }
    var oldNav = header && header.querySelector("carousel-navigation");
    var pageCount = Math.ceil(articles.length / perSlide);
    if (oldNav) oldNav.remove();
    if (pageCount > 1 && header) {
      var nav = document.createElement("carousel-navigation");
      nav.className = "page-dots magazine-toc__dots";
      nav.setAttribute("aria-controls", carouselId);
      for (var page = 0; page < pageCount; page++) {
        var button = document.createElement("button");
        button.className = "tap-area";
        button.setAttribute("aria-current", page === 0 ? "true" : "false");
        button.setAttribute("aria-label", "Aller à la diapositive " + (page + 1));
        var sr = document.createElement("span");
        sr.className = "sr-only";
        sr.textContent = "Aller à la diapositive " + (page + 1);
        button.appendChild(sr);
        nav.appendChild(button);
      }
      header.appendChild(nav);
    }
    if (oldCarousel) oldCarousel.replaceWith(carousel);
    else if (oldEmpty) oldEmpty.replaceWith(carousel);
    else root.appendChild(carousel);
  }

  function renderDossier(block, entries) {
    var rubric = block.dataset.issueRubrique || "";
    var exclude = (block.dataset.issueExclude || "").split(",").map(function (x) { return x.trim(); }).filter(Boolean);
    var results = entries.filter(function (entry) {
      return entry.tags.indexOf(rubric) !== -1 &&
        !exclude.some(function (tag) { return entry.tags.indexOf(tag) !== -1; });
    });
    if (block.dataset.issueUnlimited !== "true") {
      var limit = parseInt(block.dataset.issueLimit, 10);
      if (limit > 0) results = results.slice(0, limit);
    }
    if (sameLinks(block, ".blog-post-card__title[href]", results)) return;
    var holder = block.querySelector(".magazine-dossier__grid, scroll-carousel.magazine-dossier__carousel");
    var empty = block.querySelector(".magazine-dossier__empty");
    if (!results.length) {
      if (holder) holder.replaceChildren();
      if (empty) empty.hidden = false;
      else {
        empty = document.createElement("p");
        empty.className = "magazine-dossier__empty";
        empty.textContent = "Aucun article dans cette rubrique pour le moment.";
        block.appendChild(empty);
      }
      return;
    }
    if (empty) empty.hidden = true;
    if (!holder) {
      if (block.dataset.issueCarousel === "true") {
        var wrap = document.createElement("div");
        wrap.className = "floating-controls-container floating-controls-container--inside magazine-dossier__carousel-wrap";
        var prev = document.createElement("carousel-prev-button");
        prev.className = "floating-controls-container__control";
        var next = document.createElement("carousel-next-button");
        next.className = "floating-controls-container__control";
        var id = block.dataset.issueCarouselId;
        prev.setAttribute("aria-controls", id);
        next.setAttribute("aria-controls", id);
        prev.innerHTML = '<button type="button" class="prev-next-button prev-next-button--prev circle-button" disabled aria-label="Précédent">‹</button>';
        next.innerHTML = '<button type="button" class="prev-next-button prev-next-button--next circle-button" aria-label="Suivant">›</button>';
        holder = document.createElement("scroll-carousel");
        holder.id = id;
        holder.setAttribute("group-cells", "");
        holder.setAttribute("allow-drag", "");
        holder.className = "blog-post-list blog-post-list--carousel scroll-area snap-x bleed md:unbleed magazine-dossier__carousel";
        wrap.appendChild(prev);
        wrap.appendChild(holder);
        wrap.appendChild(next);
        block.appendChild(wrap);
      } else {
        holder = document.createElement("div");
        holder.className = "magazine-dossier__grid magazine-dossier__grid--" + (block.dataset.issueLayout || "cols-3");
        block.appendChild(holder);
      }
    }
    holder.replaceChildren();
    results.forEach(function (entry, index) {
      var card = entry.card.querySelector(".blog-post-card");
      if (!card) return;
      card = card.cloneNode(true);
      var category = card.querySelector(".blog-post-card__category");
      if (category) category.remove();
      var title = card.querySelector(".blog-post-card__title");
      if (title) { title.classList.remove("h4"); title.classList.add("h5"); }
      var excerpt = card.querySelector(".blog-post-card__excerpt");
      if (excerpt && block.dataset.issueExcerpt !== "true") excerpt.remove();
      var image = card.querySelector(".blog-post-card__image");
      if (image && block.dataset.issueImageSizes) {
        image.setAttribute("sizes", block.dataset.issueImageSizes);
        if (index > 2) image.setAttribute("loading", "lazy");
      }
      holder.appendChild(card);
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-magazine-issue-toc], [data-magazine-issue-dossiers]"), function (root) {
      if (inited.has(root)) return;
      var url = root.dataset.issueUrl, tag = root.dataset.issueTag;
      if (!url || !tag) return;
      inited.add(root);
      source(url, tag).then(function (entries) {
        if (entries.length === 0 && root.querySelector(".blog-post-card__title[href], .magazine-toc__article-title[href]")) {
          throw new Error("Magazine: unexpected empty native tag result; keeping Liquid fallback");
        }
        if (root.matches("[data-magazine-issue-toc]")) renderToc(root, entries);
        else Array.prototype.forEach.call(root.querySelectorAll("[data-issue-rubrique]"), function (block) {
          renderDossier(block, entries);
        });
      }).catch(function (error) {
        console.warn("Magazine saisonnier : affichage Liquid conservé.", error);
        inited.delete(root);
      });
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();